import { MDXRemote, type MDXRemoteSerializeResult } from "next-mdx-remote"
import type { SharedContent } from "@/utils/careers-mdx"
import { getComponents } from "./MDXComponents"

interface MDXRendererProps {
  mdxSource: MDXRemoteSerializeResult
  sharedContent?: SharedContent
}

/**
 * A CSP-friendly MDX renderer that uses next-mdx-remote
 * with appropriate settings to avoid unsafe-eval and unsafe-inline
 */
export default function MDXRenderer({ mdxSource, sharedContent }: MDXRendererProps) {
  const components = getComponents(sharedContent)

  return (
    <div className="prose prose-lg dark:prose-invert max-w-none text-base">
      <MDXRemote {...mdxSource} components={components} />
    </div>
  )
}
